export enum RecurringActionType {
  Current = "CURRENT_ONLY",
  CurrentAndFollowing = "CURRENT_AND_FOLLOWING",
  All = "ALL",
}
